import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import {
  StyledBox,
  StyledBoxDis,
  StyledBoxInner,
  StyledBoxPad,
  StyledTypographyDo,
  StyleSpan,
  StyleTypographyText,
} from "../../../pages/auth/forgot-password/style";
import theme from "../../../theme";
import CustomInput from "../../common/input/CustomInput";
import CustomButton from "../../common/button/CustomButton";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FORGOT_PASSWORD } from "../../../actions/AuthActions";

const validationSchema = Yup.object({
  emailOrPhone: Yup.string()
    .test("valid-email-or-phone", function (value) {
      if (!value) {
        return this.createError({
          message: "Enter a valid email or 10-digit phone number",
        });
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^[0-9]{10}$/;
      if (emailRegex.test(value)) return true;
      if (phoneRegex.test(value)) return true;
      return this.createError({
        message: "Enter a valid email or 10-digit phone number",
      });
    })
    .required("email or phone number is required "),
});

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const submitLock = React.useRef(false);
  const [isForgotSubmitting, setIsForgotSubmitting] = React.useState(false);
  const isAuthLoading = useSelector((state) => state.auth?.isLoading);
  const isSubmitting = isForgotSubmitting || isAuthLoading;

  const handleLogin = () => {
    navigate("/login");
  };

  const handleSubmit = (values) => {
    if (submitLock.current || isSubmitting) return;
    submitLock.current = true;
    setIsForgotSubmitting(true);

    dispatch({
      type: FORGOT_PASSWORD,
      payload: {
        ...values,
        onSuccess: () => {
          submitLock.current = false;
          setIsForgotSubmitting(false);
        },
        onError: () => {
          submitLock.current = false;
          setIsForgotSubmitting(false);
        },
      },
    });
  };

  return (
    <StyledBox>
      <StyledBoxInner>
        <StyleTypographyText>Forgot your password?</StyleTypographyText>
        <Formik
          initialValues={{ emailOrPhone: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, handleChange, handleBlur, values, touched }) => (
            <Form>
              <StyledBoxDis>
                <StyledBoxPad>
                  <CustomInput
                    label="Email / Phone Number"
                    name="emailOrPhone"
                    value={values.emailOrPhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.emailOrPhone && Boolean(errors.emailOrPhone)}
                    helperText={touched.emailOrPhone && errors.emailOrPhone}
                    autoComplete="current-emailOrPhone"
                  />
                </StyledBoxPad>

                <CustomButton
                  fontSize={theme.typography.regular.fontSize}
                  type="submit"
                  btnLabel="SUBMIT"
                  btntype={"primary"}
                  height="56px"
                  disabled={isSubmitting}
                  isLoading={isSubmitting}
                />
                <StyledTypographyDo>
                  <StyleSpan onClick={() => handleLogin()}>Login</StyleSpan>
                </StyledTypographyDo>
              </StyledBoxDis>
            </Form>
          )}
        </Formik>
      </StyledBoxInner>
    </StyledBox>
  );
};

export default ForgotPassword;
